import { useState } from 'react';

export type SortDirectionType = 'asc' | 'desc' | 'none';

type SortHookType = <T>(
  headers: Array<{
    title: string;
    getSortPayload?: (direction: SortDirectionType) => T;
  }>,
  defaultSort: { title: string; direction: SortDirectionType; payload: T }
) => {
  sort: T;
  tableHeaders: Array<{
    title: string;
    onClick: () => void;
    sortDirection: SortDirectionType;
  }>;
};

export const useSort: SortHookType = (headers, defaultSort) => {
  const [sort, setSort] = useState(defaultSort);

  const onClick = (title: string, currentDirection: SortDirectionType) => {
    const clickedHeader = headers.find(h => h.title === title);
    if (!clickedHeader!.getSortPayload) return; // not sortable

    const direction = ['none', 'desc'].includes(currentDirection)
      ? 'asc'
      : 'desc';

    setSort({
      title,
      direction,
      payload: clickedHeader!.getSortPayload(direction),
    });
  };
  const outputHeaders = headers.map(th => {
    const sortDirection = sort.title === th.title ? sort.direction : 'none';
    return {
      title: th.title,
      onClick: () => onClick(th.title, sortDirection),
      sortDirection,
    };
  });

  return {
    sort: sort.payload,
    tableHeaders: outputHeaders,
  };
};
